import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue"; //入口页
// import Home from "../views/Home.vue"; //首页
import Detail from '../views/vipDiscounts/detail.vue'
import Equity from '../views/vipDiscounts/equity.vue'
import VipDiscountsHome from "../views/vipDiscounts/home.vue"
import DiscountsDetail from '../views/vipDiscounts/detail/index.vue'
import CouponRecords from '../views/vipDiscounts/couponRecords/index.vue'
import CouponDetail from '../views/vipDiscounts/couponDetail/index.vue'
import MessagePage from '../views/vipDiscounts/messagePage/index.vue'
import ReceiveDiscount from '../views/vipDiscounts/receiveDiscount/index.vue'
import My from "../views/My.vue"; //个人中心
import Register from "../views/Register.vue"; //注册
import Exchange from "../views/Exchange.vue"; //注册
//    component: () => import("../views/Exchange.vue"),
//解决 超出最大调用堆栈大小 的问题
let originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return originalPush.call(this, to).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Index,
    children: [
      {
        path: "/",
        name: "Home",
        component: VipDiscountsHome,
        meta: {
          title: "惠享网购",
          auth: "index",
        },
      },
      {
        path: "/discountsDetail",
        name: "discountsDetail",
        component: DiscountsDetail,
        meta: {
          title: "详情",
          auth: "index",
        },
      },
      {
        path: "/couponRecords",
        name: "couponRecords",
        component: CouponRecords,
        meta: {
          title: "权益领取记录",
          auth: "index",
        },
      },
      {
        path: "/receiveDiscount",
        name: "receiveDiscount",
        component: ReceiveDiscount,
        meta: {
          title: "领取",
          auth: "index",
        },
      },
      {
        path: "/messagePage",
        name: "messagePage",
        component: MessagePage,
        meta: {
          title: "提示",
          auth: "index",
        },
      },
      {
        path: "/couponDetail",
        name: "couponDetail",
        component: CouponDetail,
        meta: {
          title: "详情",
          auth: "index",
        },
      },
      {
        path: "/detail",
        name: "detail",
        component: Detail,
        meta: {
          title: "详情",
          auth: "index",
        },
      },
      {
        path: "/equity",
        name: "equity",
        component: Equity,
        meta: {
          title: "权益说明",
          auth: "index",
        },
      },
      // {
      //   path: "/",
      //   name: "Home",
      //   component: Home,
      //   meta: {
      //     title: "首页",
      //     auth: "index",
      //   },
      // },
      {
        path: "/my",
        name: "My",
        component: My,
        meta: {
          title: "个人中心",
          auth: "my",
        },
      },
      {
        path: "/recharge",
        name: "Recharge",
        component: () => import("../views/Recharge.vue"),
        meta: {
          title: "充值中心",
          auth: "index",
        },
      },
      {
        path: "/rechargedetail",
        name: "RechargeDetail",
        component: () => import("../views/RechargeDetail.vue"),
        meta: {
          title: "充值中心",
          auth: "index",
        },
      },
      {
        path: "/goodsList/:id",
        name: "GoodsList",
        component: () => import("../views/GoodsList.vue"),
        meta: {
          title: "商品列表",
          auth: "index",
        },
      },
      {
        path: "/goodsDetail/:id",
        name: "GoodsDetail",
        component: () => import("../views/GoodsDetail.vue"),
        meta: {
          title: "商品详情",
          auth: "index",
        },
      },
      {
        path: "/orderList/:id",
        name: "OrderList",
        component: () => import("../views/OrderList.vue"),
        meta: {
          title: "",
          auth: "order",
        },
      },
      // {
      //   path: "/orderList/:id",
      //   name: "OrderList",
      //   component: () => import("../views/OrderList.vue"),
      //   meta: {
      //     title: "",
      //     auth: "my",
      //   },
      // },

      {
        path: "/orderDetail/:id/:orderId",
        name: "OrderDetail",
        component: () => import("../views/OrderDetail.vue"),
        meta: {
          title: "",
          auth: "my",
        },
      },
      {
        path: "/points",
        name: "Points",
        component: () => import("../views/Points.vue"),
        meta: {
          title: "我的趣豆",
          auth: "my",
        },
      },
      {
        path: "/gifts",
        name: "Gifts",
        component: () => import("../views/Gifts.vue"),
        meta: {
          title: "我的礼包",
          auth: "my",
        },
      },
      {
        path: "/giftDetail/:id",
        name: "GiftDetail",
        component: () => import("../views/GiftDetail.vue"),
        meta: {
          title: "我的礼包",
          auth: "my",
        },
      },
      {
        path: "/ticket",
        name: "Ticket",
        component: () => import("../views/Ticket.vue"),
        meta: {
          title: "我的卡券",
          auth: "ticket",
        },
      },
      // {
      //   path: "/ticket",
      //   name: "Ticket",
      //   component: () => import("../views/Ticket.vue"),
      //   meta: {
      //     title: "我的卡券",
      //     auth: "my",
      //   },
      // },
      {
        path: "/questions",
        name: "Questions",
        component: () => import("../views/Questions.vue"),
        meta: {
          title: "说明文档",
          auth: "my",
        },
      },
      {
        path: "/transfer",
        name: "Transfer",
        component: () => import("../views/Transfer.vue"),
        meta: {
          title: "趣豆转让",
          auth: "my",
        },
      },
      {
        path: "/afterSale/:id",
        name: "AfterSale",
        component: () => import("../views/AfterSale.vue"),
        meta: {
          title: "申请售后",
          auth: "my",
        },
      },
      {
        path: "/baseInfoChange",
        name: "BaseInfoChange",
        component: () => import("../views/BaseInfoChange.vue"),
        meta: {
          title: "个人信息",
          auth: "my",
        },
      },
      {
        path: "/exchangeSuccess/:id",
        name: "ExchangeSuccess",
        component: () => import("../views/ExchangeSuccess.vue"),
        meta: {
          title: "兑换成功",
          auth: "index",
        },
      },
    ],
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: "注册",
    },
  },
  {
    path: "/exchange",
    name: "Exchange",
    component: Exchange,
    meta: {
      title: "激活兑换码",
    },
  },
  {
    path: "/exchangeDetail/:id",
    name: "ExchangeDetail",
    component: () => import("../views/ExchangeDetail.vue"),
    meta: {
      title: "兑换详情",
    },
  },
  {
    path: "/history",
    name: "History",
    component: () => import("../views/History.vue"),
    meta: {
      title: "历史激活记录",
    },
  },
  {
    path: "/frozen",
    name: "Frozen",
    component: () => import("../views/Frozen.vue"),
    meta: {
      title: "账号冻结",
    },
  },
  {
    path: "/baseInfo",
    name: "BaseInfo",
    component: () => import("../views/BaseInfo.vue"),
    meta: {
      title: "基础信息",
    },
  },
  {
    path: "/giftDetailOut",
    name: "GiftDetailOut",
    component: () => import("../views/GiftDetailOut.vue"),
    meta: {
      title: "我的礼包",
    },
  },
  //   {
  //   path: "/test",
  //   name: "test",
  //   component: () => import("../views/test.vue"),
  //   meta: {
  //     title: "测试页面",
  //   },
  // },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
